import { render, staticRenderFns } from "./xeCompareChartSetting.vue?vue&type=template&id=328ce832"
import script from "./xeCompareChartSetting.vue?vue&type=script&lang=js"
export * from "./xeCompareChartSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports